// extracted by mini-css-extract-plugin
export default {"buttons":"FixedButtons_buttons__riRF+"};